import { maskDocument } from '~/shared/utils/masks';

import { ICompany } from '../interfaces/ICompany';
import { CompanyFormattedTypeEnum } from '../enums/CompanyTypeEnum';
import { CompanyFormattedStatusEnum } from '../enums/CompanyStatusEnum';
import { getCompanyStatusColor } from './getCompanyStatusColor';

export function formatCompany(company: ICompany): ICompany {
  const formattedDocument = maskDocument(company.document);
  const formattedType = CompanyFormattedTypeEnum[company.type];

  const formattedStatus = {
    system: CompanyFormattedStatusEnum[company.status.system],
    rental: CompanyFormattedStatusEnum[company.status.rental],
  };

  const statusColor = {
    system: getCompanyStatusColor[company.status.system],
    rental: getCompanyStatusColor[company.status.rental],
  };

  return {
    ...company,
    formattedDocument,
    formattedType,
    formattedStatus,
    statusColor,
  };
}
